document.addEventListener("DOMContentLoaded", function () {
  function DateDiff(obj) {
    let status = $(obj).data("status");
    let pint = parseInt($(obj).data("pint"));
    let custom = parseInt($(obj).data("custom"));
    let start = $(".qa-bank-share-btn-box").data("time");
    let myDate = new Date();
    let year = myDate.getFullYear(); //获取当前年
    let mon = myDate.getMonth() + 1; //获取当前月
    let date = myDate.getDate(); //获取当前日

    let sdate = new Date(start);
    let now = `${year}-${mon}-${date}`;
    let ndate = new Date(now);
    let days = ndate.getTime() - sdate.getTime() + 1;
    let day = parseInt(days / (1000 * 60 * 60 * 24));
    let count = "";
    if (status == "one") {
      count = custom + Math.ceil(custom * (day * (pint * 0.01)));
    } else {
      count = Math.ceil(day * (pint * 0.01));
    }

    $(obj).find(".automatic_count").text(count);
    return day;
  }

  $(".qa-bank-share-btn-box .cell").each(function () {
    let that = this;
    DateDiff(that);
  });

  $(".qa-bank-share-btn-box .cell").click(function () {
    let count = parseInt($(this).find(".count").text());
    $(this)
      .find(".count")
      .text(count + 1);
  });
});
